import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { ProductionAndSalesWithPaymentsDetails } from "../../../components/Pages/Documents/ProductionAndSalesWithPayments/ProductionAndSalesWithPaymentsDetail";
import ProductionAndSalesWithPaymentsList from "../../../components/Pages/Documents/ProductionAndSalesWithPayments/ProductionAndSalesWithPaymentsDetailsList";
import { NFLookupProductionAndSalesWithPayments } from "../../../components/Shared/NewForms/NFLookupProductionAndSalesWithPayments";
import { ProductionAndSalesWIthPaymentsService } from "../../../services/documents/ProductionAndSalesWIthPaymentsService";
import { CreateProductionAndSalesWithPaymentsDto } from "../../../dtos/documents/ProductionAndSalesWithPayments/CreateProductionAndSalesWithPaymentsDto";

export const ProductionAndSalesWithPayments: IAppEntity = {
  entityType: "document",
  title: "Production And Sales With Payments",
  pluralTitle: "ReceiptFromProductionAndSalesWithPayments",
  apiUrl: "ReceiptFromProductionAndSalesWithPayments",
  apiEnum: ReferenceTypes.DocumentReceiptFromProductionAndSalesWithPayment,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ProductionAndSalesWithPaymentsDetails, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ProductionAndSalesWithPaymentsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupProductionAndSalesWithPayments, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new ProductionAndSalesWIthPaymentsService("ReceiptFromProductionAndSalesWithPayments"),
  getEmptyModel: () => {
    const model: CreateProductionAndSalesWithPaymentsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
      products:[],
      materials:[],
      salary:[],
      employeeEarnings:[],
      costs:[],
      additionalProducts:[],
      advances:[],
      payment:[]
    };
    return model;
  },
};
